<template>
  <div class="">
<!--    <notifications></notifications>-->
    <div id="mp" >

      <dashboard-navbar></dashboard-navbar>
      <!-- your content here -->
      <router-view></router-view>
      <content-footer></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import SidebarShare from './SidebarSharePlugin';
import DashboardNavbar from './DashboardNavbar.vue';
import ContentFooter from './ContentFooter.vue';
import DashboardContent from './Content.vue';
import SidebarFixedToggleButton from './SidebarFixedToggleButton.vue';
import { SlideYDownTransition, ZoomCenterTransition } from 'vue2-transitions';
import {Auth} from "aws-amplify";
import {API_LOCATION} from "@/api-config";
import axios from "axios";

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    SidebarFixedToggleButton,
    DashboardContent,
    SlideYDownTransition,
    ZoomCenterTransition,
    SidebarShare
  },
  data() {
    return {
    };
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    getPaymentSettingsId(){
      if(JSON.parse(localStorage.getItem('group'))) {
        return JSON.parse(localStorage.getItem('group')).payment_settings_id
      }
      return null
    },
    getAutomatedEmailSettingsId(){
      if(JSON.parse(localStorage.getItem('group'))) {
        return JSON.parse(localStorage.getItem('group')).automated_email_configuration_id
      }
      return null
    },
  },
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}

.main-panel .zoomIn {
  animation-name: zoomIn95;
}

@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-panel .zoomOut {
  animation-name: zoomOut95;
}

/* total width */
body::-webkit-scrollbar {
  background-color: rgba(50, 50, 93, 0.24);
  width: 7px;
}

/* background of the scrollbar except button or resizer */
body::-webkit-scrollbar-track {
  background-color: rgba(50, 50, 93, 0.14);
}

/* scrollbar itself */
body::-webkit-scrollbar-thumb {
  background-color: rgba(218, 18, 18, 0.05);
  border-radius: 16px;
  border: 4px solid rgba(50, 50, 93, 0.79);
}
</style>
